/**
 * retention-1031 — 「일정 알림 받기」 블록의 클라이언트 쪽 순수 부분(번들 안전 · Node API 없음).
 *
 *   인앱 브라우저(네이버 46% · 카카오톡 등)는 웹 푸시를 받을 수 없고 쿠키·저장소도 자주 비워진다 → 다시 데려올 길은 카톡방뿐이다.
 *   그래서 인앱이면 카톡방 버튼이 «주 버튼», 이메일은 보조. 일반 브라우저는 이메일이 주 버튼, 카톡방은 보조.
 *   ⚠️ 서버 HTML 은 방문자와 무관하게 같다(기본 = email). 주/보조 전환은 수화 뒤 data 속성 하나로만 한다(CSS order).
 */
import type { InAppBrowserType } from '@/hooks/useInAppBrowser';

export type SiteAlertPrimary = 'email' | 'talk';

export function siteAlertPrimary(inApp: { isInApp: boolean; type: InAppBrowserType } | null | undefined): SiteAlertPrimary {
  return inApp?.isInApp ? 'talk' : 'email';
}

export type SiteAlertSubmitState = 'idle' | 'sending' | 'sent' | 'pending' | 'already' | 'error' | 'unavailable';

/** 서버 응답 → 화면 상태. */
export function siteAlertStateOf(httpStatus: number, body: { status?: string } | null | undefined): SiteAlertSubmitState {
  if (httpStatus === 503) return 'unavailable';
  if (httpStatus >= 400) return 'error';
  const s = body?.status;
  return s === 'pending' || s === 'already' ? s : 'sent';
}

export const SITE_ALERT_MSG: Record<Exclude<SiteAlertSubmitState, 'idle' | 'sending' | 'error'>, string> = {
  sent: '확인 메일을 보냈습니다. 메일의 「알림 신청 확인」을 누르면 신청이 끝납니다.',
  pending: '방금 확인 메일을 보냈습니다. 메일함(스팸함 포함)을 확인해 주세요.',
  already: '이미 이 현장 알림을 받고 계십니다.',
  unavailable: '메일 알림을 준비 중입니다. 지금은 카톡방에서 소식을 받아 보세요.',
};

export const SITE_ALERT_EMAIL_RE = /^[^\s@<>()",;:]+@[^\s@<>()",;:]+\.[^\s@<>()",;:]{2,}$/;
